import { render, staticRenderFns } from "./UserOrganisations.vue?vue&type=template&id=08baf595&scoped=true"
import script from "./UserOrganisations.vue?vue&type=script&lang=js"
export * from "./UserOrganisations.vue?vue&type=script&lang=js"
import style0 from "./UserOrganisations.vue?vue&type=style&index=0&id=08baf595&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08baf595",
  null
  
)

export default component.exports